//
//
//
//
//
//
//
//
//
//
//
//
//

import BrandGridItem from '../vue/BrandGridItem.vue';

export default {
	/* eslint-disable no-undef */

	data() {
		return {
			show: false,
		};
	},

	props: {
		brands: {
			default: 'one',
		},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {
		BrandGridItem,
	},

	created() {},
	mounted() {},
};



// WEBPACK FOOTER //
// ./scripts/vue/BrandGrid.vue